/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));

    /* MIGRATION: size chart modal behavior */
    function initSizeChart(root) {
      if (!root || root.dataset.sizeChartBound === "true") return;
      root.dataset.sizeChartBound = "true";

      var viewer = root.querySelector("[data-size-chart-viewer-inner]");
      var actions = root.querySelector("[data-size-chart-actions]");
      var openLink = root.querySelector("[data-size-chart-open]");
      var items = root.querySelectorAll("[data-size-chart-item]");
      var downloadLabel = root.dataset.sizeChartDownloadLabel || "Download file";

      function renderItem(item) {
        if (!item || !viewer) return;

        var url = item.dataset.sizeChartUrl;
        var kind = item.dataset.sizeChartKind;
        var label = item.dataset.sizeChartLabel || "";

        if (!url) return;

        viewer.innerHTML = "";

        if (kind === "pdf") {
          var objectEl = document.createElement("object");
          objectEl.type = "application/pdf";
          objectEl.data = url;
          viewer.appendChild(objectEl);
        } else if (kind === "image") {
          var img = document.createElement("img");
          img.src = url;
          img.alt = label;
          viewer.appendChild(img);
        } else {
          var wrapper = document.createElement("p");
          var link = document.createElement("a");
          link.href = url;
          link.target = "_blank";
          link.rel = "noopener";
          link.textContent = downloadLabel;
          wrapper.appendChild(link);
          viewer.appendChild(wrapper);
        }

        if (actions) actions.hidden = false;
        if (openLink) openLink.href = url;

        items.forEach(function (button) {
          button.classList.remove("is-active");
          button.setAttribute("aria-pressed", "false");
        });

        item.classList.add("is-active");
        item.setAttribute("aria-pressed", "true");
      }

      if (items.length > 0) {
        renderItem(items[0]);
      }

      root.addEventListener("click", function (event) {
        var button = event.target.closest("[data-size-chart-item]");
        if (!button) return;
        renderItem(button);
      });
    }

    document.addEventListener("tooltip:open", function (event) {
      if (!event.detail || event.detail.context !== "size-chart") return;
      window.setTimeout(function () {
        var toolTip = document.querySelector(
          "tool-tip[data-tool-tip-open='true'][data-tool-tip='size-chart']"
        );
        if (!toolTip) return;
        var root = toolTip.querySelector("[data-size-chart-root]");
        if (!root) return;
        initSizeChart(root);
      }, 0);
    });
  });
})();
